import React from 'react';
export function HeroDecorations() {
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-0 hidden lg:block" data-id="element-126">
      {/* Top Right Concentric Circles */}
      <svg className="absolute -top-12 -right-12 w-72 h-72 text-rise-gold/40" viewBox="0 0 100 100" fill="none" data-id="element-127">
        <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="0.5" strokeDasharray="4 6" data-id="element-128" />
        <circle cx="50" cy="50" r="30" stroke="currentColor" strokeWidth="0.5" data-id="element-129" />
        <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="0.5" strokeDasharray="2 4" data-id="element-130" />
      </svg>
      {/* Top Left Small Circles */}
      <svg className="absolute top-24 left-12 w-24 h-24 text-rise-gold/50" viewBox="0 0 100 100" fill="none" data-id="element-131">
        <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="0.8" data-id="element-132" />
        <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="0.8" data-id="element-133" />
      </svg>
      {/* Bottom Left Dot Grid */}
      <svg className="absolute bottom-12 left-24 w-32 h-32 text-rise-gold/60" viewBox="0 0 100 100" data-id="element-134">
        <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-135">
          <circle cx="2" cy="2" r="1.5" fill="currentColor" data-id="element-136" />
        </pattern>
        <rect x="0" y="0" width="100" height="100" fill="url(#dots)" data-id="element-137" />
      </svg>
      {/* Bottom Right Diagonal Lines */}
      <svg className="absolute -bottom-8 right-24 w-48 h-48 text-rise-gold/30" viewBox="0 0 100 100" fill="none" data-id="element-138">
        <line x1="0" y1="100" x2="100" y2="0" stroke="currentColor" strokeWidth="0.8" data-id="element-139" />
        <line x1="20" y1="100" x2="100" y2="20" stroke="currentColor" strokeWidth="0.8" data-id="element-140" />
        <line x1="40" y1="100" x2="100" y2="40" stroke="currentColor" strokeWidth="0.8" data-id="element-141" />
        <line x1="60" y1="100" x2="100" y2="60" stroke="currentColor" strokeWidth="0.8" data-id="element-142" />
      </svg>
      {/* Scattered Gold Dots */}
      <div className="absolute top-1/3 right-1/4 w-2 h-2 rounded-full bg-rise-gold/70" data-id="element-143"></div>
      <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 rounded-full bg-rise-gold/50" data-id="element-144"></div>
      <div className="absolute top-1/2 left-1/4 w-3 h-3 rounded-full bg-rise-gold/40" data-id="element-145"></div>
    </div>;
}
export function ImageDecorations({
  type = 1
}: {
  type?: 1 | 2;
}) {
  if (type === 1) {
    return <div className="absolute inset-0 pointer-events-none z-[-1]" data-id="element-146">
        {/* Double offset borders */}
        <div className="absolute inset-0 border border-rise-gold/40 rounded-xl translate-x-5 translate-y-5" data-id="element-147"></div>
        <div className="absolute inset-0 border border-rise-gold/20 rounded-xl translate-x-8 translate-y-2" data-id="element-148"></div>
        {/* L-shaped brackets */}
        <svg className="absolute -top-4 -right-4 w-12 h-12 text-rise-gold" viewBox="0 0 100 100" fill="none" data-id="element-149">
          <path d="M 0 0 L 100 0 L 100 100" stroke="currentColor" strokeWidth="2" data-id="element-150" />
        </svg>
        <svg className="absolute -bottom-4 -left-4 w-12 h-12 text-rise-gold" viewBox="0 0 100 100" fill="none" data-id="element-151">
          <path d="M 100 100 L 0 100 L 0 0" stroke="currentColor" strokeWidth="2" data-id="element-152" />
        </svg>
      </div>;
  }
  return <div className="absolute inset-0 pointer-events-none z-[-1]" data-id="element-153">
      {/* Double offset borders */}
      <div className="absolute inset-0 border border-rise-gold/40 rounded-xl translate-x-5 translate-y-5" data-id="element-154"></div>
      <div className="absolute inset-0 border border-rise-gold/30 rounded-xl -translate-x-3 -translate-y-3" data-id="element-155"></div>
      {/* Scattered Crosses */}
      <svg className="absolute -top-8 -left-8 w-6 h-6 text-rise-gold/60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-156">
        <path d="M12 2v20M2 12h20" data-id="element-157" />
      </svg>
      <svg className="absolute bottom-12 -right-6 w-4 h-4 text-rise-gold/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-158">
        <path d="M12 2v20M2 12h20" data-id="element-159" />
      </svg>
    </div>;
}
export function AboutDecorations() {
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-0 hidden lg:block" data-id="element-160">
      {/* Top Right Rotated Diamonds */}
      <svg className="absolute -top-16 -right-8 w-48 h-48 text-rise-gold/30" viewBox="0 0 100 100" fill="none" data-id="element-161">
        <rect x="50" y="10" width="40" height="40" transform="rotate(45 50 10)" stroke="currentColor" strokeWidth="0.8" data-id="element-162" />
        <rect x="50" y="30" width="20" height="20" transform="rotate(45 50 30)" stroke="currentColor" strokeWidth="0.8" data-id="element-163" />
      </svg>
      {/* Top Left Starburst */}
      <svg className="absolute top-12 -left-12 w-32 h-32 text-rise-gold/40" viewBox="0 0 100 100" fill="none" data-id="element-164">
        <circle cx="50" cy="50" r="2" fill="currentColor" data-id="element-165" />
        <line x1="50" y1="10" x2="50" y2="40" stroke="currentColor" strokeWidth="0.8" data-id="element-166" />
        <line x1="50" y1="60" x2="50" y2="90" stroke="currentColor" strokeWidth="0.8" data-id="element-167" />
        <line x1="10" y1="50" x2="40" y2="50" stroke="currentColor" strokeWidth="0.8" data-id="element-168" />
        <line x1="60" y1="50" x2="90" y2="50" stroke="currentColor" strokeWidth="0.8" data-id="element-169" />
        <line x1="20" y1="20" x2="40" y2="40" stroke="currentColor" strokeWidth="0.8" data-id="element-170" />
        <line x1="80" y1="80" x2="60" y2="60" stroke="currentColor" strokeWidth="0.8" data-id="element-171" />
        <line x1="20" y1="80" x2="40" y2="60" stroke="currentColor" strokeWidth="0.8" data-id="element-172" />
        <line x1="80" y1="20" x2="60" y2="40" stroke="currentColor" strokeWidth="0.8" data-id="element-173" />
      </svg>
      {/* Bottom Left Cascading Lines */}
      <svg className="absolute -bottom-12 left-12 w-40 h-40 text-rise-gold/50" viewBox="0 0 100 100" fill="none" data-id="element-174">
        <line x1="0" y1="20" x2="80" y2="20" stroke="currentColor" strokeWidth="0.8" data-id="element-175" />
        <line x1="0" y1="40" x2="60" y2="40" stroke="currentColor" strokeWidth="0.8" data-id="element-176" />
        <line x1="0" y1="60" x2="40" y2="60" stroke="currentColor" strokeWidth="0.8" data-id="element-177" />
        <line x1="0" y1="80" x2="20" y2="80" stroke="currentColor" strokeWidth="0.8" data-id="element-178" />
      </svg>
      {/* Bottom Right Organic Curves */}
      <svg className="absolute bottom-0 right-0 w-64 h-64 text-rise-gold/30" viewBox="0 0 100 100" fill="none" data-id="element-179">
        <path d="M 0 100 Q 50 50 100 100" stroke="currentColor" strokeWidth="0.8" strokeDasharray="4 6" data-id="element-180" />
        <path d="M 20 100 Q 60 60 100 80" stroke="currentColor" strokeWidth="0.8" data-id="element-181" />
      </svg>
    </div>;
}